export default __webpack_public_path__ + "static/media/search.9a492888.svg";